import moment from 'moment'

/** Expiry runs to the end of the stated day, as the backend's `RightToWorkDocument::hasExpired()` does. */
export function isDocumentExpired(expiresAt?: string | null): boolean {
  return Boolean(expiresAt) && moment(expiresAt).endOf('day').isBefore(moment())
}

/** Matches the `useDate` default, so document dates read like every other date in the app. */
export function formatDocumentDate(value?: string | null): string {
  return value ? moment(value).format('MMM DD, YYYY') : ''
}

/** Read at call time rather than cached, so a form left open across midnight still offers tomorrow. */
export function earliestExpiryDate(): string {
  return moment().add(1, 'day').format('YYYY-MM-DD')
}
